export default "__VITE_ASSET__COp_qvmI__"